import { Component, Input } from '@angular/core';
import { DialogsService } from '../../services/dialogs.service';
import { TipComponent } from '../tip-component/tip.component';
import { DocsFieldsEnum } from '../../enum/docs-fields.enum';

@Component({
    selector: 'tip-link',
    templateUrl: './tip-link.component.html',
    styleUrls: ['./tip-link.component.scss'],
})
export class TipLinkComponent {

    @Input() public field;

    constructor(
        public dialogsService: DialogsService,
    ) {}

    public openTip($event: Event, field) {
        $event.preventDefault();
        $event.stopPropagation();

        switch (field) {
            case DocsFieldsEnum.RG_EMISSOR:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-rg-emissor.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.RG_UF_EMISSOR:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-rg-uf-emissor.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.RG_NUMBER:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-rg-number.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.RG_DATA_EXPEDICAO:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-rg-data.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_NUMBER:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-num-cnh.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_UF_EMISSOR:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-uf-emissor.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_DATA_EMISSAO:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-dt-emissao.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_DATA_VALIDADE:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-cnh-data-validade.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_SEGURANCA:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'img-cd-seguranca.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.CNH_NOME:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'cnh-nome.png', title: 'Dica' });
                break;
            case DocsFieldsEnum.RG_NOME:
                this.dialogsService.showComponentAsAsidePanel(TipComponent, true, { image: 'rg-nome.png', title: 'Dica' });
                break;
            default:
                break;
        }
    }
}
